/* eslint-disable @typescript-eslint/naming-convention */
export const gradient = {
	background: {
		dark: {
			1: 'linear-gradient(90deg, #0D4DFB 36%, #4771FF 100%)',
			2: 'linear-gradient(90deg, #0038BC 36%, #0D4DFB 100%)',
			3: 'linear-gradient(90deg, #003193 36%, #003CD6 100%)',
		},
		light: {
			1: 'linear-gradient(84deg, #FEF2F2 0.21%, #FFFAED 28.89%, #FFFFEB 99.64%)',
			2: 'linear-gradient(82deg, #E2EFFF 0.7%, #F0F7FF 32.05%, #FFFFEB 97.1%)',
			3: 'linear-gradient(84deg, #FEF2F2 0.21%, #FAF8FD 45.88%, #FFFFEB 99.64%)',
		},
	},
	fill: {
		interactive: {
			default: 'linear-gradient(90deg, #FFDB00 0%, #FFE600 100%)',
			hover: 'linear-gradient(90deg, #FFB64D 0%, #FFE600 100%)',
			pressed: 'linear-gradient(90deg, #FE9311 0%, #FFDB00 100%)',
		},
		progress: 'linear-gradient(90deg, #0038BC 34.13%, #4771FF 75.48%, #4AAEFF 92.79%)',
	},
	icon: 'linear-gradient(0deg, #FE9311 0%, #FFDB00 100%)',
	stroke: {
		interactive: {
			default: 'linear-gradient(180deg, #FFE986 0%, #FFD000 98.5%)',
			strong: 'linear-gradient(0deg, #FFB64D 0%, #FFE600 100%)',
		},
	},
};
